module.exports = __webpack_public_path__ + "img/mariee.402e1e4.png";